﻿export class PointSet {
    constructor(public Id: number, public Datetime: Date, public Factor: number) {

    }
}